module.exports = __webpack_public_path__ + "static/arslan.072f5f7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/about/arslan.png
// module id = 568
// module chunks = 263791100135453